import React from 'react';
import { Routes, Route } from "react-router-dom";
import Landing from './pages/Landing';
import Home from './pages/Home'
import Create from './pages/Create'
import About from './pages/About'
import Details from './pages/Details'
import PageNotFound from './pages/PageNotFound'
import './App.css';
import axios from "axios";
axios.defaults.baseURL = "https://dog-appi-production.up.railway.app/"


function App() {
  return (
    <Routes>
      <Route path="/" exact element={<Landing />} />
      <Route path="/home" element={<Home />} />
      <Route path="/create" element={<Create />} />
      <Route path="/details/:id" element={<Details />} />
      <Route path="/about" element={<About />} />
      <Route element={<PageNotFound />} />
    </Routes>
  );
}

export default App;
